import React, {Component} from 'react';
import Spinner from 'react-spinner-material';
import couterpart from 'counterpart';

import ImportFileService from '../services/ImportFileService';
import AuthenticationService from '../services/AuthenticationService';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import "../css/style.css";
import {FaUpload} from 'react-icons/fa';
import {MdFileUpload} from 'react-icons/md';
import { ICON_COLOR } from '../icon';

class FileUploader extends Component{
    state = {
        file: null,
        spinnerVisible: false,
        duplicated: ''
    }


    handleFile(e){
        console.log(e.target.files, "$$$$");
        let file = e.target.files;
        this.setState({file}, ()=>{
            if (file != null && file.length > 0){
                var selectedFiles = "";
                var fileSep = "";
                for(var i=0; i<file.length;i++){
                    selectedFiles += fileSep + file[i].name;
                    fileSep = ",";
                }
                
                this.setState({
                    selectedFilenames: selectedFiles
                });
            }
        });
    }

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    handleUpload(e){
        try{
            this.setState({spinnerVisible: true}, () =>{
                if (AuthenticationService.isUserLoggedIn() === false){
                    console.log("Un-authenticated");
                    this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
                    return;
                }

                let files = this.state.file;
                if ((files === null) || (files === undefined) || (files.length < 1)){
                    ToastsStore.error("Please select files to upload.");
                    this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
                    return;
                }
                ImportFileService.uploadFiles(files).then(data => {
                    if ((data === null) || (data === undefined) || (data.Result < 1)){
                        ToastsStore.info(couterpart.translate('msg_import_nodata'));
                    }else{
                        console.log('IMPORTED_INFO', data);
                        if (data.upload_error !== undefined){
                            ToastsStore.info(data.upload_error);
                        } else {
                            this.setState({
                                duplicated: data.duplicated
                            })
                            ToastsStore.info(couterpart.translate('imported_orders_count') + data.numberOfItems);
                        }
                    }
                    
                    this.props.handleUpdate(e);
                    this.clearInputFile(e);
                    this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
                });
            });
        }catch(e){
            this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
        }
    }

    handleUploadImages (e) {
        try{
            this.setState({spinnerVisible: true}, () =>{
                if (AuthenticationService.isUserLoggedIn() === false){
                    console.log("Un-authenticated");
                    this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
                    return;
                }

                let files = this.state.file;
                if ((files === null) || (files === undefined) || (files.length < 1)){
                    ToastsStore.error("Please select files to upload.");
                    this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
                    return;
                }
                ImportFileService.uploadCustomerFiles(files).then(data => {
                    if ((data === null) || (data=== undefined) || (data.Result < 1)){
                        ToastsStore.info(couterpart.translate('msg_import_nodata'));
                    }else{
                        if (data === 'OK'){
                            ToastsStore.info(couterpart.translate('msg_upload_image_ok'));
                        }else{
                            alert(couterpart.translate('msg_upload_image_ko') + ": " + data);
                        }
                    }
                    
                    this.props.handleUpdate(e);
                    this.clearInputFile(e);
                    this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
                });
            });
        }catch(e){
            this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
        }
    }

    clearInputFile(e){
        //this.setState({file: null, selectedFilenames: '', inputKey:''},()=>{
        //});
    }

    render(){
        if (AuthenticationService.isService() || AuthenticationService.isAdmin()){
            let duplicatedTitle = '';
            if (this.state.duplicated && this.state.duplicated.length > 0){
                duplicatedTitle = couterpart.translate('imported_orders') + ': ';
            }
            return (
                <div>
                    <h3>{this.props.caption}</h3>
                    
                    <form name="frmFiles">
                        <div>
                            <label htmlFor="fileData"><MdFileUpload color="green"/> 
                            {this.state.selectedFilenames}</label>
                            <input key={this.state.inputKey} type="file"  id="fileData" name="fileData" multiple onChange={(e) => this.handleFile(e)}/>
                        </div>
                        <button className="myButton" type="button" onClick={(e) => this.handleUpload(e)}>
                            <FaUpload color={ICON_COLOR}/>&nbsp;
                            {couterpart.translate('button_upload_order')}
                        </button>&nbsp;&nbsp;&nbsp;
                        <button className="myButton" type="button" onClick={(e) => this.handleUploadImages(e)}>
                            <FaUpload color={ICON_COLOR}/>&nbsp;
                            {couterpart.translate('button_upload_custmer_files')}
                        </button>                        
                    </form>&nbsp;&nbsp;
                    <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
                    <ToastsContainer store={ToastsStore} position="bottom_center" timer={5000} />
                    <span>{duplicatedTitle}</span><br/>
                    <pre>{ this.state.duplicated } </pre>
                </div>
            );
        }else{
            return (
                <div>&nbsp;</div>
            );
        }
    }
}

export default FileUploader;